import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { saveNewRecentPlace } from '@spothero/search-component';
export const useDefaultSuggestion = () => {
    const { city: { data: city }, destination: { data: destination }, event: { data: event }, search: { data: { searchType, destinationTitle }, }, searchRequest: { starts, ends, latitude, longitude }, } = useSelector((state) => state);
    let defaultSuggestion;
    // save place when ever we useDefaultSuggestion.  If the values change it should resave.  This is triggering a few times, unsure if we like this or not
    switch (searchType) {
        case 'city':
            defaultSuggestion = {
                description: `${city.city}, ${city.state}`,
                location: {
                    latitude: city.latitude,
                    longitude: city.longitude,
                },
            };
            saveNewRecentPlace(defaultSuggestion);
            break;
        case 'event':
            defaultSuggestion = {
                eventTitle: event.title,
                description: `${destination.title}, ${destination.city}, ${destination.state}`,
                id: event.id,
                parkingWindow: {
                    ends: dayjs
                        .tz(event.parking_window.ends, destination.timezone)
                        .format(),
                    starts: dayjs
                        .tz(event.parking_window.starts, destination.timezone)
                        .format(),
                },
                starts: dayjs.tz(starts, destination.timezone).format(),
                ends: dayjs.tz(ends, destination.timezone).format(),
                eventStart: dayjs.tz(event.starts, 'UTC').format(),
                eventEnd: dayjs.tz(event.ends, 'UTC').format(),
                location: {
                    latitude: latitude,
                    longitude: longitude,
                },
                venue: event.destination_id,
                venueTitle: destination.title,
            };
            saveNewRecentPlace({
                description: `${destination.title}, ${destination.city}, ${destination.state}`,
                location: {
                    latitude: latitude,
                    longitude: longitude,
                },
                distance_meters: 0,
                matched_substrings: [],
                bypassForVenueUrl: `/search?kind=destination&id=${destination.id}`, // Probably want to fix this so it keeps other query params but this is a fast implementation
            });
            break;
        case 'destination':
        case 'venue':
            defaultSuggestion = {
                description: `${destination.title}, ${destination.city}, ${destination.state}`,
                location: {
                    latitude: destination.latitude,
                    longitude: destination.longitude,
                },
            };
            saveNewRecentPlace({
                ...defaultSuggestion,
                bypassForVenueUrl: `/search?kind=destination&id=${destination.id}`, // Probably want to fix this so it keeps other query params but this is a fast implementation
            });
            break;
        case 'address':
            defaultSuggestion = {
                description: destinationTitle,
                location: {
                    latitude: latitude,
                    longitude: longitude,
                },
            };
            if (
            // Bypass saving for two scenarios.  will need to be revisted if the destinationTitle changes
            !(destinationTitle === 'Current Location' ||
                destinationTitle === 'Destination')) {
                saveNewRecentPlace(defaultSuggestion);
            }
            break;
        case 'airport':
            defaultSuggestion = {
                description: `${destination?.airport?.airport_name || ''}`,
                location: {
                    latitude: destination.latitude,
                    longitude: destination.longitude,
                },
            };
            saveNewRecentPlace(defaultSuggestion);
            break;
        default:
            defaultSuggestion = undefined;
            break;
    }
    return defaultSuggestion;
};
